export default __webpack_public_path__ + "static/media/Poppers_Prosecco.d9497371.mp3";